import { render } from "./BackButton.vue?vue&type=template&id=b23eaf0e&ts=true"
import script from "./BackButton.vue?vue&type=script&lang=ts"
export * from "./BackButton.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__